module.exports = __webpack_public_path__ + "img/contact2.27341369.svg";